import React, { useContext, useState, useEffect } from "react"
import TopSearch from "@/components/TopSearch"
import ListComponent from "@/components/listComponent"
import { getWvAccessRecord } from "@/service/allCarService"
import { MyContext } from "@/store/myContext"
import { getPcodeDict } from "@/utils/dataStorage"
import YhTooltip from "@/erp_subpackage/components/YhTooltip"
//访问列表
export default () => {
    const { state, Option } = useContext(MyContext)
    const [goodsList, setGoodsList] = useState([]) //列表
    const [searchValue, setSearchValue] = useState({})
    const [pagination, setpagination] = useState({
        //分页配置
        total: 0,
        current: 1,
        pageSize: 10,
    })

    useEffect(() => {
        if (state.activeMenu === "allCarAccessRecord") {
            loadData(pagination.current)
        }
    }, [state.activeMenu])// eslint-disable-line react-hooks/exhaustive-deps

    //列表数据
    const loadData = (current, search = {}) => {
        let data = {
            searchItem: { ...search },
            pageNum: current,
            pageSize: 10,
            orders: [
                {
                    column: "updateTime",
                    rule: "DESC",
                },
            ],
        }
        getWvAccessRecord(data)
            .then((res) => {
                // if (res && res.retCode === 200) {
                    setpagination({
                        current: current,
                        total: res.retData.total,
                        pageSize: 10,
                    })
                    setGoodsList(res.retData.list)
                // } else {
                //     message.warning(res.retMsg)
                // }
            })
            // .catch((err) => message.error(err.retMsg))
    }
    //分页事件 置空当前行信息
    const onTableChange = async (page) => {
        await setpagination({
            ...pagination,
            current: page.current,
        })
        loadData(page.current, searchValue)
    }

    //table配置
    const columns = [
        {
            title: "客户名称",
            align: "center",
            dataIndex: "customerName",
            render: (text) => <YhTooltip text={text} />,
        },
        {
            title: "用户名",
            align: "center",
            dataIndex: "customerUserName",
        },
        {
            title: "用户电话",
            align: "center",
            dataIndex: "commodityAmount",
        },
        {
            title: "所属地区",
            align: "center",
            dataIndex: "commodityCostPrice",
        },
        {
            title: "访问日期",
            align: "center",
            dataIndex: "commodityRetailPrice",
        },
        {
            title: "访问页面",
            align: "center",
            dataIndex: "commodityUnderlinedPrice",
        },
        {
            title: "访问车型",
            align: "center",
            dataIndex: "commodityPointPrice",
        },
        {
            title: "停留时常",
            align: "center",
            dataIndex: "accessStayTime",
        },
    ]
    //搜索JSON
    const searchList = {
        normalList: [
            {
                type: "select",
                placeholder: "请选择区域",
                valueName: "commodityType",
                optionList: () =>
                    getPcodeDict("025").children.map((item) => (
                        <Option key={item.id} value={item.dictCode}>
                            {item.title}
                        </Option>
                    )),
            },
            {
                type: "input",
                placeholder: "请输入客户名称",
                valueName: "commodityName",
            },
            {
                type: "input",
                placeholder: "请输入联系人",
                valueName: "commodityName1",
            },
            {
                type: "RangePicker",
                valueName: ["startTime", "endTime"],
                span: 16,
                xxl: 8,
            },
        ],
    }

    return (
        <>
            {state.activeMenu === "allCarAccessRecord" && (
                <>
                    <TopSearch
                        title="访问记录"
                        searchListData={searchList}
                        searchValue={searchValue}
                        setSearchValue={(obj) => setSearchValue(obj)}
                        handleSearch={loadData}
                    />
                    <ListComponent title="访问记录" columns={columns} dataSource={goodsList} pagination={pagination} onTableChange={onTableChange} />
                </>
            )}
        </>
    )
}
